

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import AnchoredComponent from './AnchoredComponent';

class RiskFinderComponent extends AnchoredComponent {

  static propTypes = {
    // placeType: PropTypes.string.isRequired,
    // placeID: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      data: {}
    }
  }

  componentDidMount() {
    super.componentDidMount();
    this.loadData();
  }

  componentDidUpdate(props) {
    if (props.placeID !== this.props.placeID || props.placeType !== this.props.placeType) {
      this.loadData();
    }
    if (props.waterLevel.level != this.props.waterLevel.level ||
      props.waterLevel.unit !== this.props.waterLevel.unit ||
      props.protection !== this.props.protection) {
      this.update();
    }
  }

  hasData() {
    return this.state && this.state.data && Object.keys(this.state.data).length > 0;
  }

  summarizeData() {}

  update() {
    if (this.hasData()) {
      this.summarizeData();
    }
  }

  loadData() { }

  render() {
    return (
      <div className="RiskFinderComponent"></div>
    );
  };
}

export default RiskFinderComponent;
